import { type ReserveType } from '@utils/itinerary';
import type { BreadcrumbItem } from '#imports';

type BreadcrumbKey = ReserveType | `international-${ReserveType}`;

export const breadcrumbPaths: Record<BreadcrumbKey, BreadcrumbItem[]> = {
    train: [
        { link: '/train-ticket', title: 'بلیط قطار' },
        { link: '/trains/$city', title: 'بلیط قطار $cityName' },
        {
            link: '/trains/$ORG-$city',
            title: 'بلیط قطار $ORGName به $cityName',
        },
    ],
    flight: [
        { link: '/plane-ticket', title: 'بلیط هواپیما' },
        { link: '/flights/$city', title: 'بلیط هواپیما $cityName' },
        {
            link: '/flights/$ORG-$city',
            title: 'بلیط هواپیما $ORGName به $cityName',
        },
    ],
    'international-flight': [
        { link: '/plane-ticket', title: 'بلیط هواپیما' },
        { link: '/international-flights', title: 'بلیط هواپیما خارجی' },
        { link: '/flights/$city', title: 'بلیط $cityName' },
        {
            link: '/flights/$ORG-$city',
            title: 'بلیط هواپیما $ORGName $cityName',
        },
    ],
    bus: [
        { link: '/bus-ticket', title: 'بلیط اتوبوس' },
        { link: '/buses/$city', title: 'بلیط اتوبوس $cityName' },
        {
            link: '/buses/$ORG-$city',
            title: 'بلیط اتوبوس $ORGName به $cityName',
        },
    ],
    taxi: [
        { link: '/taxi', title: 'بلیط سواری' },
        { link: '/taxi/$city', title: 'بلیط سواری $cityName' },
        { link: '/taxi/$ORG-$city', title: 'بلیط سواری $ORGName به $cityName' },
    ],
    hotel: [{ link: '/hotel', title: 'رزرو هتل' }],
    ship: [{ link: '/ship', title: 'بلیط کشتی' }],
    bundle: [{ link: '/tour', title: 'بسته‌های سفر' }],
    'train-tour': [],
    'international-train': [],
    'international-bus': [],
    'international-taxi': [],
    'international-hotel': [],
    'international-ship': [],
    'international-train-tour': [],
    'international-bundle': [],
};
